/* eslint-disable */

/** Contains a list of DataPrivacySetting. */
export interface DataPrivacySettings {
  settings?: DataPrivacySetting[];
}

/** Defines the settings for a particular data privacy system. */
export interface DataPrivacySetting {
  system?: DataPrivacySettingSystem;
  enabled?: boolean;
}

export enum DataPrivacySettingSystem {
  APPSFLYER = "APPSFLYER",
  ANALYTICS = "ANALYTICS",
  CRASH_REPORTING = "CRASH_REPORTING",
}
